module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "moveDiv",
    staticClass: "xuanfu-wrapper",
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        return _vm.startDrag.apply(null, arguments)
      },
      "mousemove": _vm.onDrag,
      "mouseup": _vm.stopDrag
    }
  }, [_c('transition', {
    attrs: {
      "name": "menu-fade"
    }
  }, [(_vm.showMenu) ? _c('div', {
    staticClass: "kf-menu",
    class: {
      'menu-left': _vm.menuOnLeft
    },
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
      },
      "mousemove": function($event) {
        $event.stopPropagation();
      },
      "mouseup": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "kf-item",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onCustomer.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-chat-dot-round"
  }), _vm._v(" "), _c('span', [_vm._v("联系客服")])]), _vm._v(" "), _c('div', {
    staticClass: "kf-item"
  }, [_c('i', {
    staticClass: "el-icon-phone-outline"
  }), _vm._v(" "), _c('span', [_vm._v("客服电话")]), _vm._v(" "), _c('div', {
    staticClass: "phone-tip"
  }, [_vm._v("400 088 3316")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "xuanfu",
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('img', {
    staticClass: "img-kf",
    attrs: {
      "src": _vm.iconSrc
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24f732be","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/components/customerSer.vue
// module id = 627
// module chunks = 0